
import { RouteRecordRaw } from "vue-router";

/**
 * Routes available for all tenants
 * @type {Array<RouteRecordRaw>}
 */
export const commonRoutes: Array<RouteRecordRaw> = [
    {
        path: '/user-profile',
        name: 'user-profile',
        component: () => import('@/pages/user-profile/UsersProfileView.vue'),
        meta: {
            title: 'User Profile',
        },
    },
    {
        path: '/company-profile',
        name: 'company-profile',
        component: () => import('@/pages/company-profile/CompanyProfilePage.vue'),
        meta: {
            title: 'Company Profile',
        },
    }

]